import Header from '@/components/Header.vue'
import EditListing from '@/components/EditListing'
import Preview from '@/components/listingComponents/Preview.vue'
import ListingSearch from '@/components/ListingSearch.vue'
import embedMarket from '@/components/embedMarket.vue'
import { getCurrentFirebaseUser } from '@/platform/auth/services/authService.js'

export default [
    {
        path: '/editListing',
        name: 'editListing',
        components: {
            header: Header,
            content: EditListing
        },
        props: {
            header: true,
            content: true
        },
        beforeEnter(to, from, next) {
            let user = getCurrentFirebaseUser()
            if (user && !user.isAnonymous) {
                if (from.path == '/') {
                    next('/dashboard')
                } else {
                    next()
                }
            } else {
                next('/login')
            }
        }
    },
    {
        path: '/listing/:listingId',
        name: 'listing',
        components: {
            header: Header,
            content: Preview
        },
        props: {
            header: true,
            content: true
        }
    },
    {
        path: '/',
        name: 'marketplace',
        components: {
          header: Header,
          content: ListingSearch
        },
        beforeEnter(to, from, next) {
          let user = getCurrentFirebaseUser()
          if (user && !user.isAnonymous) {
            next('/dashboard')
          }else{
            next('/login')
          }
        }
    },
    {
        path: '/market',
        name: 'listingsearch',
        components: {
          header: Header,
          content: ListingSearch
        },
        beforeEnter(to, from, next) {
          next()
        }
    },
    {
        path: '/embed/market',
        name: 'embedmarket',
        components: {
          content: embedMarket
        },
        beforeEnter(to, from, next) {
          next()
        }
    },
]


// WEBPACK FOOTER //
// ./src/router/listing/index.js